import { GET_FULL_STAT } from './types';
import { Analitics } from './api';

export const getFullStatAction = id => async dispatch => {
  const response = await Analitics.getFullStat(id);
  if (!response.error) {
    dispatch({ type: GET_FULL_STAT, payload: response.data.full_stat });
  } else {
    return response.error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/analitics/actions.js